var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiVariateOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 40,
    viewBox: "0 0 48 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 40,
    height: 40,
    rx: 6,
    fill: "#272D55"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 25C22.4122 25 21.3488 25.3226 20.4444 25.9269C19.5399 26.5313 18.8349 27.3902 18.4187 28.3952C18.0024 29.4002 17.8935 30.5061 18.1057 31.573C18.3179 32.6399 18.8417 33.6199 19.6109 34.3891C20.3801 35.1583 21.3601 35.6821 22.427 35.8943C23.4939 36.1065 24.5998 35.9976 25.6048 35.5813C26.6098 35.1651 27.4687 34.4601 28.0731 33.5556C28.6774 32.6512 29 31.5878 29 30.5C29 29.0413 28.4205 27.6424 27.3891 26.6109C26.3576 25.5795 24.9587 25 23.5 25ZM23.5 33.25C22.9561 33.25 22.4244 33.0887 21.9722 32.7865C21.5199 32.4844 21.1675 32.0549 20.9593 31.5524C20.7512 31.0499 20.6967 30.4969 20.8028 29.9635C20.909 29.4301 21.1709 28.94 21.5555 28.5555C21.9401 28.1709 22.4301 27.9089 22.9635 27.8028C23.497 27.6967 24.0499 27.7512 24.5524 27.9593C25.0549 28.1675 25.4844 28.5199 25.7865 28.9722C26.0887 29.4244 26.25 29.9561 26.25 30.5C26.25 31.2293 25.9603 31.9288 25.4445 32.4445C24.9288 32.9603 24.2293 33.25 23.5 33.25Z",
    fill: "#E3ECFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7852 19.7851L10.5356 11.5355",
    stroke: "#E3ECFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5354 19.7851V11.5355H18.785",
    stroke: "#E3ECFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0175 19.2669L37.2671 11.0173",
    stroke: "#E3ECFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0173 11.0174H37.2669V19.2669",
    stroke: "#E3ECFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiVariateOperationIcon);
export default __webpack_public_path__ + "static/media/BiVariateOperationIcon.7f1bac950e07c9541b227962fb4c831f.svg";
export { ForwardRef as ReactComponent };